import React from 'react';
import { styled } from '../../styles/stitches.config';
import { Badge, Day, Month, Post, Posts, TopBar } from '../../styles/lesson/lesson.style';
import { formatInTimeZone } from 'date-fns-tz';
import { useUser } from '../../contextManager/user.context';

export const CalendarBadge: React.FC<{ date: string }> = ({ date }) => {
  const { userDetails } = useUser();
  const tz = userDetails?.timezone || 'Europe/London';
  const d = new Date(date);
  const day = formatInTimeZone(d, tz, 'd');
  const month = formatInTimeZone(d, tz, 'MMM');

  return (
    <Badge role="img" aria-label={`Event on ${d.toDateString()}`}>
      <TopBar />
      <Posts>
        <Post />
        <Post />
      </Posts>
      <Day>{day}</Day>
      <Month>{month}</Month>
    </Badge>
  );
};
